import { Component } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { TitleService } from '../services/common/title.service';

@Component({
    selector: 'test-certificate',
    template: require('./../templates-to-remove/testCertificate.component.html'),
    providers: [TitleService]
})
export class TestCertificateComponent {
    code: string;

    constructor(private router: Router, private titleService: TitleService, private route: ActivatedRoute) {

    }

    ngOnInit() {
        this.titleService.setTitle(this.route.snapshot.data['title']);
    }

    public invoke() {
        this.router.navigate(['certificate'], { queryParams: { code: this.code }});
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular2-router-loader/src!./ClientApp/app/components-to-remove/testCertificate.component.ts